import { SaveVirtualAircraftContractEntryAction, scheduleActions } from '../../actions';
import api from '../../../../../../../services/api';
import {call, put} from 'redux-saga/effects';
import MODAL_MODE from '../../../../../common/constants';
import {
  saveVirtualAircraftContractRequest,
  saveVirtualAircraftContractSuccess,
  saveVirtualAircraftContractFailure,
} from './actions';

export function* saveVirtualAircraftContract(action) {
  const { form } = action.payload;

  try {
    // 1. Dispatch the request action to set a loading state
    yield put(saveVirtualAircraftContractRequest());

    const response = yield call(api.post, '/v1/contracts/virtual/aircraft', {
      CurrentAircraftContractIDs: form.aircraftContractIDs,
      NewValues: {
        AircraftIDs: form.aircraftIDs,
        ClientContractID: form.clientContractID,
        StartDate: form.startDate,
        EndDate: form.endDate,
      },
    });

    // 2. Dispatch the success action with the response
    yield put(saveVirtualAircraftContractSuccess(response.data));

    // Also close the modal on success
    yield put(
      scheduleActions.setGroupedAircraftContractModalMode({
        open: false,
        mode: MODAL_MODE.create,
      })
    );
  } catch (err) {
    // 3. Dispatch the failure action on error
    yield put(saveVirtualAircraftContractFailure(err));
    console.log('failed to post a new form item', err);
  }
}
